const ProjectMilestoneStatusActions = {
  SubmitForApproval: "SubmitForApproval",
  Release: "Release",
  Skip: "Skip",
  Reenable: "Reenable",
  Reset: "Reset",
  Approve: "Approve",
  Reject: "Reject",
};

export default ProjectMilestoneStatusActions;
